import React, {Component} from 'react';
import NavLinkItem from "./NavLinkItem";
import {Link} from 'react-router-dom';
import {withRouter} from "react-router";
import PermissionsRequired from "../utils/components/PermissionsRequired";
import BackEnd from "../backend/BackEnd";
import ActionLink from "../controls/ActionLink";
import AdvertTypeModal from "./modals/AdvertTypeModal";

const $ = window.jQuery;

class NavMenu extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showAdvertTypeModal: false,
        newTenders: null,
        activeTenders: null,
        underwayTenders: null,
        incomingTenderRequests: null,
        activeTenderRequests: null,
        underwayTenderRequests: null
    };
    countersInterval = null;

    componentDidMount() {
        this.$el = $(this.el);
        this.$el.pxNav();

        $(document).on('fetchCounters', () => this.fetchCounters());

        this.countersInterval = setInterval(() => this.fetchCounters(), 10 * 1000);
        this.fetchCounters();
    }

    componentWillUnmount() {
        this.$el.pxNav('destroy');

        $(document).off('fetchCounters');

        if (this.countersInterval)
            clearInterval(this.countersInterval);
    }

    render() {
        return (
            <nav ref={el => this.el = el} className="px-nav px-nav-left">
                <button type="button" className="px-nav-toggle" data-toggle="px-nav">
                    <span className="px-nav-toggle-arrow"/>
                    <span className="navbar-toggle-icon"/>
                    <span className="px-nav-toggle-label font-size-11">Скрыть меню</span>
                </button>
                <ul className="px-nav-content">
                    <li className="px-nav-box p-a-3 b-b-1" id="demo-px-nav-box">
                        <div className="font-size-16"><span className="font-weight-light">Добро пожаловать</span></div>
                    </li>
                    <PermissionsRequired permissions={[1201]} allowAnonymous={true}>
                        <NavLinkItem to="/" exact className="px-nav-item" activeClassName="active">
                            <i className="px-nav-icon ion-document"/>
                            <span className="px-nav-label">Объявления</span>
                        </NavLinkItem>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1001, 1002, 1003, 1004]}>
                    <li className="px-nav-item px-nav-dropdown">
                        <a href="#">
                            <i className="px-nav-icon ion-cube"/>
                            <span className="px-nav-label">Тендеры</span>
                        </a>
                        <ul className="px-nav-dropdown-menu">
                            <PermissionsRequired permissions={[1001]}>
                                <NavLinkItem to="/tenders/new"
                                             className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Новые</span>
                                    {
                                        !!this.state.newTenders &&
                                        <span className="label label-primary">{this.state.newTenders}</span>
                                    }
                                </NavLinkItem>
                            </PermissionsRequired>
                            <PermissionsRequired permissions={[1002]}>
                                <NavLinkItem to="/tenders/active"
                                             className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Активные</span>
                                    {
                                        !!this.state.activeTenders &&
                                        <span className="label label-primary">{this.state.activeTenders}</span>
                                    }
                                </NavLinkItem>
                            </PermissionsRequired>
                            <PermissionsRequired permissions={[1003]}>
                                <NavLinkItem to="/tenders/underway"
                                             className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">В работе</span>
                                    {
                                        !!this.state.underwayTenders &&
                                        <span className="label label-primary">{this.state.underwayTenders}</span>
                                    }
                                </NavLinkItem>
                            </PermissionsRequired>
                            <PermissionsRequired permissions={[1004]}>
                                <NavLinkItem to="/tenders/all"
                                             className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Все заказы</span>
                                </NavLinkItem>
                            </PermissionsRequired>
                        </ul>
                    </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1101, 1102, 1103, 1104]}>
                        <li className="px-nav-item px-nav-dropdown">
                            <a href="#">
                                <i className="px-nav-icon ion-arrow-graph-up-right"/>
                                <span className="px-nav-label">Заказы</span>
                            </a>
                            <ul className="px-nav-dropdown-menu">
                                <PermissionsRequired permissions={[1101]}>
                                    <NavLinkItem to="/tenderRequests/incoming"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Новые</span>
                                        {
                                            !!this.state.incomingTenderRequests &&
                                            <span className="label label-primary">{this.state.incomingTenderRequests}</span>
                                        }
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1102]}>
                                    <NavLinkItem to="/tenderRequests/accepted"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Мои торги</span>
                                        {
                                            !!this.state.activeTenderRequests &&
                                            <span className="label label-primary">{this.state.activeTenderRequests}</span>
                                        }
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1103]}>
                                    <NavLinkItem to="/tenderRequests/underway"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">В работе</span>
                                        {
                                            !!this.state.underwayTenderRequests &&
                                            <span className="label label-primary">{this.state.underwayTenderRequests}</span>
                                        }
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1104]}>
                                    <NavLinkItem to="/tenderRequests/archived"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Архив</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                            </ul>
                        </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1301, 1302, 1306, 1307, 1308]}>
                        <li className="px-nav-item px-nav-dropdown">
                            <a href="#">
                                <i className="px-nav-icon ion-ios-list-outline"/>
                                <span className="px-nav-label">Справочники</span>
                            </a>
                            <ul className="px-nav-dropdown-menu">
                                <PermissionsRequired permissions={[1301]}>
                                    <NavLinkItem to="/catalogs/contractors"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Контрагенты 1С</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1302]}>
                                    <NavLinkItem to="/catalogs/users"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Пользователи</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1306]}>
                                    <NavLinkItem to="/catalogs/articles"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Номенклатура</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1307]}>
                                    <NavLinkItem to="/catalogs/products"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Продукция</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1308]}>
                                    <NavLinkItem to="/catalogs/companies"
                                                 className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Компании</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                            </ul>
                        </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1401, 1402, 1403, 1404]}>
                        <li className="px-nav-item px-nav-dropdown">
                            <a href="#">
                                <i className="px-nav-icon ion-gear-a"/>
                                <span className="px-nav-label">Система</span>
                            </a>
                            <ul className="px-nav-dropdown-menu">
                                <PermissionsRequired permissions={[1401]}>
                                    <NavLinkItem to="/system/forms" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Формы</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1402]}>
                                    <NavLinkItem to="/system/notifications" className="px-nav-item"
                                                 activeClassName="active">
                                        <span className="px-nav-label">Уведомления</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1403]}>
                                    <NavLinkItem to="/system/permissions" className="px-nav-item"
                                                 activeClassName="active">
                                        <span className="px-nav-label">Права доступа</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1404]}>
                                    <NavLinkItem to="/system/ui" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Интерфейс</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1405]}>
                                    <NavLinkItem to="/system/applications" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Приложения</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1406]}>
                                    <NavLinkItem to="/system/settings" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Настройки</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                            </ul>
                        </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510]}>
                        <li className="px-nav-item px-nav-dropdown">
                            <a href="#">
                                <i className="px-nav-icon ion-settings"/>
                                <span className="px-nav-label">Для разработчиков</span>
                            </a>
                            <ul className="px-nav-dropdown-menu">
                                <PermissionsRequired permissions={[1510]}>
                                    <NavLinkItem to="/developer/overview" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Сводный обзор</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1501]}>
                                    <NavLinkItem to="/developer/sql" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">SQL профайлер</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1502]}>
                                    <NavLinkItem to="/developer/mongodb" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">MongoDB профайлер</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1503]}>
                                    <NavLinkItem to="/developer/telemetry" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Телеметрия</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1504]}>
                                    <NavLinkItem to="/developer/errors" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Ошибки</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1505]}>
                                    <NavLinkItem to="/developer/events" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">События</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1506]}>
                                    <NavLinkItem to="/developer/audit" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Аудит</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1507]}>
                                    <NavLinkItem to="/developer/workflow" className="px-nav-item"
                                                 activeClassName="active">
                                        <span className="px-nav-label">Воркфлоу</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1508]}>
                                    <NavLinkItem to="/developer/tasks" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Задачи</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                                <PermissionsRequired permissions={[1509]}>
                                    <NavLinkItem to="/developer/performance" className="px-nav-item" activeClassName="active">
                                        <span className="px-nav-label">Производительность</span>
                                    </NavLinkItem>
                                </PermissionsRequired>
                            </ul>
                        </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1601, 1602, 1603]}>
                    <li className="px-nav-item px-nav-dropdown">
                        <a href="#">
                            <i className="px-nav-icon ion-ios-pie"/>
                            <span className="px-nav-label">Отчёты</span>
                        </a>
                        <ul className="px-nav-dropdown-menu">
                            <PermissionsRequired permissions={[1601]}>
                                <NavLinkItem to="/reports/analytics" className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Аналитика</span>
                                </NavLinkItem>
                            </PermissionsRequired>
                            <PermissionsRequired permissions={[1602]}>
                                <NavLinkItem to="/reports/favorite" className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Избранные</span>
                                </NavLinkItem>
                            </PermissionsRequired>
                            <PermissionsRequired permissions={[1603]}>
                                <NavLinkItem to="/reports/list" className="px-nav-item" activeClassName="active">
                                    <span className="px-nav-label">Список</span>
                                </NavLinkItem>
                            </PermissionsRequired>
                        </ul>
                    </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[9901]}>
                        <NavLinkItem to="/contacts" className="px-nav-item" activeClassName="active">
                            <i className="px-nav-icon ion-ios-location"/>
                            <span className="px-nav-label">Контакты</span>
                        </NavLinkItem>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[9902]}>
                        <NavLinkItem to="/partners" className="px-nav-item" activeClassName="active">
                            <i className="px-nav-icon ion-ribbon-b"/>
                            <span className="px-nav-label">Партнёры и акции</span>
                        </NavLinkItem>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1005]}>
                        <li className="px-nav-box b-t-1 p-a-2">
                            <Link to="/tenders/create" className="btn btn-primary btn-block btn-outline">
                                Создать тендер
                            </Link>
                        </li>
                    </PermissionsRequired>
                    <PermissionsRequired permissions={[1202]} allowAnonymous={true}>
                        <li className="px-nav-box p-y-1 p-x-2">
                            <ActionLink className="btn btn-primary btn-block"
                                        onClick={() => this.setState({showAdvertTypeModal: true})}>
                                Купить/Продать поддоны
                            </ActionLink>
                        </li>
                        <AdvertTypeModal show={this.state.showAdvertTypeModal}
                                         onHide={() => this.setState({showAdvertTypeModal: false})}/>
                    </PermissionsRequired>
                </ul>
            </nav>
        );
    }

    async fetchCounters() {
        let getCounters = new BackEnd.Shell.GetCounters();
        let counters = await getCounters.call();

        this.setState({...counters});
    }
}

export default withRouter(NavMenu);


// WEBPACK FOOTER //
// ./src/components/NavMenu.js